import { render } from "./UserProfile.vue?vue&type=template&id=22066b10&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=22066b10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22066b10"]])

export default __exports__